import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import {
  faBell,
  faCog,
  faEnvelopeOpen,
  faSearch,
  faPowerOff,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import {
  Row,
  Col,
  Nav,
  Form,
  Image,
  Navbar,
  Dropdown,
  Container,
  Modal,
  ListGroup,
  InputGroup,
  Button,
} from "@themesberg/react-bootstrap";
import DefaultUser from "../assets/img/defaultuser/default-user.png";
import DefaultAgency from "../assets/img/defaultagency/default-agency.png";
import Cookies from "universal-cookie"; // For handling cookies
import NOTIFICATIONS_DATA from "../data/notifications";
import Profile3 from "../assets/img/team/profile-picture-3.jpg";
import { getProfile, getProfileSuperAdmin } from "../services/apis";

export default (props) => {
  const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
  const cookies = new Cookies(); // Initialize cookies instance
  const history = useNavigate(); // useHistory hook for navigation
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [agencyData, setAgencyData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [role, setRole] = useState("Admin");

  const areNotificationsRead = notifications.reduce(
    (acc, notif) => acc && notif.read,
    true
  );

  const markNotificationsAsRead = () => {
    setTimeout(() => {
      setNotifications(notifications.map((n) => ({ ...n, read: true })));
    }, 300);
  };

  const handleLogout = () => {
    history("/login");
    cookies.remove("zk-vg");
  };

  // Fetch user data based on role (Admin or Super Admin)
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      let response;

      // Fetch based on the role
      if (role === "super admin") {
        response = await getProfileSuperAdmin();
      } else {
        response = await getProfile();
      }

      // Check if the response is successful
      if (response && response.statuscode === 1) {
        setUsersData(response.data.user);
        setAgencyData(response.data.agency);
      } else {
        setError("Failed to fetch users data. Please try again later.");
      }
    } catch (error) {
      setError("Failed to fetch users data. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [role]);

  const Notification = (props) => {
    const { link, sender, image, time, message, read = false } = props;
    const readClassName = read ? "" : "text-danger";

    return (
      <ListGroup.Item action href={link} className="border-bottom border-light">
        <Row className="align-items-center">
          <Col className="col-auto">
            <Image
              src={image}
              className="user-avatar lg-avatar rounded-circle"
            />
          </Col>
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="h6 mb-0 text-small">{sender}</h4>
              </div>
              <div className="text-end">
                <small className={readClassName}>{time}</small>
              </div>
            </div>
            <p className="font-small mt-1 mb-0">{message}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };

  return (
    <div>
      <Navbar variant="dark" expanded className="ps-0 pe-1 pb-0">
        <Container fluid className="px-0">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
              <div className="media-body ms-1 text-dark align-items-center d-none d-lg-block">
                {agencyData ? (
                  <img
                    src={agencyData.agencylogo || DefaultAgency}
                    width={25}
                    style={{ borderRadius: 5, border: "1px solid gray" }}
                  />
                ) : null}
              </div>
              <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                <span className="mb-0 font-medium fw-bold">
                  {agencyData ? agencyData.agency : null}
                </span>
              </div>
            </div>

            <Nav className="align-items-center">
              <div className="media d-flex align-items-center">
                <div className="media-body me-3 text-dark align-items-center d-flex ">
                  <div className="media-body ms-1 text-dark align-items-center d-none d-lg-block">
                    {usersData ? (
                      <img
                        src={usersData.profilepic || DefaultUser}
                        width={25}
                        style={{ borderRadius: 5, border: "1px solid gray" }}
                      />
                    ) : null}
                  </div>
                  <span className="mb-0 ms-2 font-medium fw-bold">
                    {usersData ? usersData.username : "User"}
                  </span>
                </div>

                <button
                  className="btn btn-link text-danger ms-0 p-0 rounded-circle"
                  onClick={() => setShowLogoutModal(true)}
                  style={{ backgroundColor: "#fbc9c9", height: 30, width: 30 }}
                >
                  <FontAwesomeIcon icon={faPowerOff} className="text-danger" />{" "}
                </button>
              </div>
            </Nav>
          </div>
        </Container>
      </Navbar>

      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => handleLogout()}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
